import {useAuth} from '@apps-common/auth-react';
import {ENVIRONMENTS, NavBar} from '@apps-common/ui-components';
import AppsDropdown from '@apps-common/ui-components/NavBar/AppsDropdown.jsx';
import AppsMenu from '@apps-common/ui-components/NavBar/AppsMenu.jsx';
import HelpMenu from '@apps-common/ui-components/NavBar/HelpMenu.jsx';
import NavMenuLink from '@apps-common/ui-components/NavBar/NavMenuLink.jsx';
import {useFlags} from 'launchdarkly-react-client-sdk';
import React from 'react';
import {reset, trackEvent} from '../analytics.js';

const Header = () => {
  const auth = useAuth();
  const {pipShowAppsDropdown: showAppsDropdown} = useFlags();

  const logOut = async () => {
    trackEvent('Logout Button clicked');

    reset();

    return auth.signOut();
  };

  return (
    <div className="pl-mode-dark">
      <NavBar
        title={
          showAppsDropdown ? (
            <AppsDropdown
              appKey="basemapsViewer"
              environment={ENVIRONMENTS.production}
            />
          ) : (
            'Basemaps Viewer'
          )
        }
        user={auth.user?.claims}
        logout={logOut}
        secondary={
          <>
            <HelpMenu>
              <NavMenuLink
                href="https://developers.planet.com/docs/apps/basemapsviewer/"
                data-qe="user-guide-link"
              >
                User Guide
              </NavMenuLink>
            </HelpMenu>

            {!showAppsDropdown && (
              <AppsMenu
                environment={ENVIRONMENTS.production}
                includeLegacySentinelHubApps={!!auth.user?.claims.sh_user_id}
              />
            )}
          </>
        }
        environment={ENVIRONMENTS.production}
        logoUrl={
          !showAppsDropdown
            ? 'https://www.planet.com/products/planet-insights-platform/'
            : ''
        }
      />
    </div>
  );
};

export default Header;
